import React, {Component} from 'react';
import {Dimmer, Form, Segment, TextArea} from 'semantic-ui-react';
import './App.css';
import FriSelection from "../../scripts/kbd/FriSelection.js";
import AltX from "../../scripts/kbd/AltX.js";
import Tipkovnica from "../../scripts/kbd/Tipkovnica.js";
import FriServer from "../../scripts/server/server.js"
import FriLoading from "../FriLoading";
import Settings from "../settings/Settings";
import CharGrid from "../charGrid/CharGrid";
import FriMenuPre from "../menu/FriMenu";

export default class Precrkuj extends Component {
    frikeyboard;
    friserver;
    orig;

    ver = "1.2.2 Adventna antilopa";

    constructor(props) {
        super(props);
        Settings.save("v", this.ver);
        this.state = {
            loading: false,
            chargridopen: false,
            loadingText: "",
            text: {original: "", razstavljeno: "", sestavljeno: "", lang: "slv"},
            active: {show: true, message: "Nalagam..."},
            isSettingsOpen: false

        };
    }

    openCharGrid() {
        this.setState({chargridopen: !this.state.chargridopen});
    }

    componentDidMount() {
        this.friserver = new FriServer("frivola.si", this.startEngine.bind(this), this.handleShow.bind(this));
        this.orig.focus();
    }


    startEngine() {
        this.handleShow(false);
        this.frikeyboard = new Tipkovnica(this.updateElement.bind(this));
        document.addEventListener("keydown", this.handleKeyDown.bind(this));
        document.addEventListener("keyup", this.handleKeyUp.bind(this));

    }

    handleShow = (a, b) => this.setState({active: {show: a, message: a ? b : " "}});

    render() {
        return (
            <div className="App">
                <Dimmer.Dimmable style={{height: "100%", padding: "0"}} as={Segment} blurring
                                 dimmed={this.state.active.show}>
                    <FriMenuPre doAltX={this.altx.bind(this)} openChar={this.openCharGrid.bind(this)}
                                all={this.state.text}
                                openSettings={this.openSettings.bind(this)} loading={this.state.loading}
                                loadingText={this.state.loadingText}/>
                    <Form className={"form"}>
                        <div><CharGrid active={this.state.chargridopen} back={this.insertToVnos.bind(this)}/></div>
                        <TextArea ref={(e) => this.orig = e} onChange={this.request.bind(this)}
                                  className={"tekstboksPre"}
                                  autoHeight
                                  placeholder='Vnos'/>
                        <TextArea value={this.state.text.sestavljeno} autoHeight
                                  className={"tekstboksPre"} placeholder='Prečrkovano iz' readOnly/>
                        <TextArea value={this.state.text.razstavljeno} autoHeight
                                  className={"tekstboksPre"} placeholder='Prečrkovano v' readOnly/>
                    </Form>
                    <Settings refresh={this.updateOrig.bind(this)} isOpen={this.state.isSettingsOpen}
                              closeSettings={this.closeSettings.bind(this)}/>
                    <FriLoading active={this.state.active}/>
                </Dimmer.Dimmable>
            </div>
        );


    }

    closeSettings() {
        this.setState({isSettingsOpen: false})
    }

    openSettings() {
        this.setState({isSettingsOpen: true})
    }

    handleKeyUp(event) {
        if (AltX.checkIfAltX(event)) {
            this.handleAltX(event);
        }
        else {
            this.frikeyboard.handleKbdUp(event);
        }
    }

    handleKeyDown(event) {
        if (AltX.checkIfAltX(event)) {
            this.handleAltX(event);
        }
        else {
            this.frikeyboard.handleKbdDown(event);
        }
    }

    altx() {
        let frisel = new FriSelection(this.orig.ref);
        this.insertToVnos(AltX.toCharFromChar(frisel.getInputSelection().content));

        let frisel1 = new FriSelection(this.sest.ref);
        this.insertToVnos(AltX.toCharFromChar(frisel1.getInputSelection().content))
    }

    handleAltX(event) {
        this.handleAltxRef(event.target);
    }

    handleAltxRef(ref) {
        let frisel = new FriSelection(ref);
        let ret = frisel.getInputSelection();
        if (ret.content.length > 0) {
            let altx = new AltX(ret.content);
            frisel.replaceSelectedText(altx.getAltx());
            this.updateElement(ref);
        }
    }

    updateElement(event1) {
        this.request(null, event1)
    }

    updateOrig() {
        this.request(null, this.orig.ref)
    }

    async request(text, t) {
        this.setState({loading: true});
        try {
            const response = await fetch(Settings.load("server") + '/allPrecrkuj', {
                method: 'POST', body: t.value, headers: {
                    "scriptcode": Settings.load("pre_lang"),
                    "biblio": Settings.load("biblio") === "true" ? "1" : "0",
                }
            });
            const json = await response.json();
            this.setState({
                text: {
                    original: json.original,
                    sestavljeno: json.precrkovanoIz,
                    razstavljeno: json.precrkovanoV
                }
            });
            this.setState({
                loadingText: response.status === 200 ? "" : "Prišlo je do napake. Prosimo da poskusite znova kasneje.",
                loading: false
            });
        }
        catch (e) {
            this.setState({loadingText: "Prišlo je do napake. Prosimo da poskusite znova kasneje.", loading: false});
            this.friserver = new FriServer("frivola.si", this.startEngine.bind(this), this.handleShow.bind(this));
        }
    }

    insertToVnos(text) {
        let frisel = new FriSelection(this.orig.ref);
        frisel.replaceSelectedText(text);
        this.updateElement(this.orig.ref);
    }
}


// WEBPACK FOOTER //
// ./src/components/main/Precrkuj.js